import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexCenterAligned, flexColumn, openingEffect } from '@/styles/common';

export const ToggleButton = styled.button`
  ${flexCenterAligned}
  position: absolute;
  top: 46px;
  right: 16px;
  width: 34px;
  height: 34px;
  background-color: transparent;
  border: 1px solid var(--border-main);
  border-radius: 28px;
  cursor: pointer;
  color: var(--textAndLabels-main);
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: var(--bg-secondary);
  }
`;

export const Popup = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  ${flexColumn}
  gap: 10px;
  background: var(--bg-main);
  border-radius: 16px 16px 0 0;
  padding: 25px 16px 10px;
  z-index: 60;
  ${openingEffect(80)}
`;

export const PopupHeader = styled(Typography).attrs({ variant: 'h4' })`
  padding-bottom: 20px;
`;

export const PopupItem = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  text-align: start;
  padding: 13px 0;
`;

export const PopupItemLogout = styled(PopupItem)`
  margin-top: 15px;
  color: var(--system-red);
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--border-secondary);
`;
